import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { heroImages, agency } from "../mock";
import { Button } from "./ui/button";

export default function Hero() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroImages.length), 6000);
    return () => clearInterval(t);
  }, []);

  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="accueil" className="relative h-screen min-h-[640px] w-full overflow-hidden">
      {/* Slides */}
      {heroImages.map((img, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-[1400ms] ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={img}
            alt="Immobilier Boulogne-Billancourt"
            className={`h-full w-full object-cover ${i === idx ? "hero-zoom" : ""}`}
          />
        </div>
      ))}

      {/* Warm overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#2b2620]/70 via-[#2b2620]/45 to-[#2b2620]/80" />

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-5 md:px-8 flex flex-col justify-center">
        <div className="max-w-3xl">
          <p className="text-accent-foreground/0" />
          <span className="inline-block text-white/90 tracking-[0.4em] text-xs md:text-sm mb-5 border-l-2 border-accent pl-4">
            AGENCE IMMOBILIÈRE — FNAIM
          </span>
          <h1 className="font-serif text-white text-5xl md:text-7xl leading-[1.05] font-semibold">
            Acheter, louer, vendre
            <br />
            <span className="italic text-accent">& gérer</span> rien que pour vous
          </h1>
          <p className="text-white/85 text-lg md:text-xl mt-6 max-w-xl font-light">
            Au cœur de {agency.city}, une équipe de conseillers à votre écoute
            pour faire aboutir vos projets immobiliers dans les meilleures conditions.
          </p>
          <div className="flex flex-wrap gap-4 mt-9">
            <Button
              onClick={() => go("#estimation")}
              className="bg-accent hover:bg-accent/90 text-accent-foreground rounded-full px-8 h-12 text-base"
            >
              Estimation
            </Button>
            <Button
              onClick={() => go("#services")}
              variant="outline"
              className="rounded-full px-8 h-12 text-base bg-transparent border-white/60 text-white hover:bg-white hover:text-foreground"
            >
              Nos services
            </Button>
          </div>
        </div>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {heroImages.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className={`h-1.5 rounded-full transition-all duration-300 ${
              i === idx ? "w-8 bg-accent" : "w-2.5 bg-white/50"
            }`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Scroll cue */}
      <button
        onClick={() => go("#services")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/80 hover:text-white animate-bounce"
        aria-label="Défiler"
      >
        <ChevronDown className="h-7 w-7" />
      </button>
    </section>
  );
}
